import Input from "../../../../componentLibrary/Input";

export type TimeframeMode = "cue" | "time";

type Props = {
  mode: TimeframeMode;
  onModeChange: (mode: TimeframeMode) => void;
  cue: string;
  onCueChange: (value: string) => void;
  timeframe: string;
  onTimeframeChange: (value: string) => void;
};

const segmentBtn =
  "flex-1 py-2.5 px-3 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-electrum-300";

function segmentClass(selected: boolean) {
  return selected
    ? `${segmentBtn} bg-electrum-100 text-electrum font-semibold`
    : `${segmentBtn} bg-white text-gray-600 hover:bg-gray-50`;
}

export default function TimeframeFields({
  mode,
  onModeChange,
  cue,
  onCueChange,
  timeframe,
  onTimeframeChange,
}: Props) {
  function handleCueChange(value: string) {
    onCueChange(value);
    if (value) onTimeframeChange("");
  }

  function handleTimeframeChange(value: string) {
    onTimeframeChange(value);
    if (value) onCueChange("");
  }

  return (
    <div>
      <div
        className="flex w-full rounded-md border border-electrum-200 overflow-hidden mb-3 shadow-light"
        role="group"
        aria-label="When"
      >
        <button
          type="button"
          className={`${segmentClass(mode === "cue")} border-r border-electrum-200`}
          aria-pressed={mode === "cue"}
          onClick={() => onModeChange("cue")}
        >
          Cue
        </button>
        <button
          type="button"
          className={segmentClass(mode === "time")}
          aria-pressed={mode === "time"}
          onClick={() => onModeChange("time")}
        >
          Scheduled time
        </button>
      </div>
      {mode === "cue" ? (
        <div>
          <label
            htmlFor="plan-cue"
            className="block text-sm font-medium text-gray-400 mb-2"
          >
            Cue: When...
          </label>
          <Input
            id="plan-cue"
            placeholder="I feel anxious..."
            value={cue}
            onChange={(e) => handleCueChange(e.target.value)}
          />
        </div>
      ) : (
        <div>
          <label
            htmlFor="plan-timeframe"
            className="block text-sm font-medium text-gray-400 mb-2"
          >
            Time:
          </label>
          <Input
            id="plan-timeframe"
            placeholder="Weekday at noon"
            value={timeframe}
            onChange={(e) => handleTimeframeChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
}
